import React from 'react';
import LogItem from './LogItem';

const KpiLogItem = ({ event, handleOpen }) => {
  const details = {
    itemType: 'kpi',
    actualItem: event?.kpi,
    previousItem: event?.oldKpi,
    ...event
  };

  return (
    <LogItem event={ details } handleOpen={ handleOpen }/>
  );
};

export default KpiLogItem;
